"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@mui/styles");

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _HasFeature = _interopRequireDefault(require("../../../hocs/HasFeature/HasFeature"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    navigationItem: {
      fontWeight: 'bold'
    },
    active: {
      color: palette.primary.main
    },
    link: {
      display: 'block',
      margin: spacing(3, 0)
    }
  };
});

var SidebarSettingsMenu = function SidebarSettingsMenu(_ref2) {
  var settings = _ref2.settings,
      parentUrl = _ref2.parentUrl,
      location = _ref2.location;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, settings.map(function (_ref3) {
    var link = _ref3.link,
        label = _ref3.label,
        featureFlag = _ref3.featureFlag;
    var to = "".concat(parentUrl, "/").concat(link);
    var activeClassName = location.includes(to) ? classes.active : '';

    if (featureFlag) {
      return /*#__PURE__*/_react.default.createElement(_HasFeature.default, {
        key: link,
        featureKey: featureFlag
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        to: to,
        className: (0, _classnames.default)(activeClassName, classes.link)
      }, label));
    }

    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      key: link,
      to: to,
      className: (0, _classnames.default)(activeClassName, classes.link)
    }, label);
  }));
};

SidebarSettingsMenu.propTypes = {
  settings: _propTypes.default.arrayOf(_propTypes.default.shape({
    link: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    featureFlag: _propTypes.default.string
  })).isRequired,
  parentUrl: _propTypes.default.string.isRequired,
  location: _propTypes.default.string.isRequired
};
var _default = SidebarSettingsMenu;
exports.default = _default;